module.exports = __webpack_public_path__ + "static/media/alison-brie-lose.92ad6e7a.jpg";